const ExecutionEntryCompleted = () => {
  return <></>
}

export default ExecutionEntryCompleted
